import 'bootstrap/dist/css/bootstrap.min.css';
import './style/shared.css';
import React from 'react'
import { dateToDateTimeString, dateToDateString } from '../utilities/DateFormatting.js'
import { enumToPresentableString, userToPresentableName, getSignedInEmail } from '../utilities/StringUtils.js'
import { bucketClaimsByDay } from '../utilities/ClaimUtils.js'
import { Table, Button } from 'react-bootstrap';
import PopupAlert from './PopupAlert.js'
import EditClaim from './EditClaim.js'
import { GetTodayClaims, GetArchivedClaims, ClaimFile } from '../network/ApiManager'
import { withRouter } from 'react-router';

class Claims extends React.Component {
  constructor(props) {
    super(props);
    this.state = { popupClaim: null, editClaim: null, claims: [], expandedClaimIds: {} }
    this.selectClaim = this.selectClaim.bind(this);
    this.deselectClaim = this.deselectClaim.bind(this);
    this.refreshClaims = this.refreshClaims.bind(this);
    this.rowsForClaim = this.rowsForClaim.bind(this);
    this.openEditClaim = this.openEditClaim.bind(this);
    this.toggleClaimDetails = this.toggleClaimDetails.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  componentDidMount() {
    this.interval = setInterval(() => this.refreshClaims(), 120000)
    this.refreshClaims()
  }

  refreshClaims() {
    console.log(`Refreshing claims... (${new Date()})`);

    const { isAdmin } = this.props;

    if (isAdmin) {
      GetArchivedClaims((claims) => {
         const buckets = bucketClaimsByDay(claims)
         this.setState({ claims: buckets })
      }, (error) => {
          console.error(`${JSON.stringify(error)}`);
      })
    }
    else {
      GetTodayClaims((claims) => {
         const buckets = bucketClaimsByDay(claims)
         this.setState({ claims: buckets })
      }, (error) => {
          console.error(`${JSON.stringify(error)}`);
      })
    }
  }

  openEditClaim(claim) {
    const signedInEmail = getSignedInEmail()
    const { isAdmin } = this.props;
    const isClaimOwner = (claim.owner && signedInEmail && claim.owner.email === signedInEmail)
    if (isClaimOwner || isAdmin) {
      this.setState({ editClaim: claim, popupClaim: null })
    }
  }

  selectClaim(claim) {
    const { isAdmin } = this.props;
    if (!claim.ownership || isAdmin) {
      this.setState({ popupClaim: claim, editClaim: null })
    }
  }

  editClaim(claim) {
    if (claim) {
      const updatedClaim = claim;
      const claims = this.state.claims.map(cs => cs.map(c => c.id === updatedClaim.id ? updatedClaim : c));

      this.setState({ claims, popupClaim: null, editClaim: null })
    }
    else {
      this.setState({ editClaim: null, popupClaim: null })
    }
  }

  deselectClaim(claim) {
    if (claim) {
      ClaimFile(claim.id, (updatedClaim) => {
        const claims = this.state.claims.map(cs => cs.map(c => c.id === updatedClaim.id ? updatedClaim : c));
        this.setState({ popupClaim: null, editClaim: null, claims })
      }, (error) => {
        alert(error)
      })
    }
    else {
      this.setState({ popupClaim: null, editClaim: null })
    }
  }

  linkToClaim(claim) {
    if (claim.pdfUrl) {
      const maxDisplayLength = 200
      const isS3 = claim.pdfUrl.includes(".s3.us-east-2.amazonaws.com")
      const name = isS3 ? claim.pdfUrl.split('/').pop() : `${claim.pdfUrl.substring(0, maxDisplayLength)}${claim.pdfUrl.length > maxDisplayLength ? '...' : ''}`
      return (<a target="_blank" rel="noreferrer" href={`${claim.pdfUrl}`} title={name}>{name}</a>)
    }
    else {
      return (<div/>)
    }
  }

  toggleClaimDetails(claimId) {
    this.setState((state) => ({
      expandedClaimIds: {
        ...state.expandedClaimIds,
        [claimId]: !state.expandedClaimIds[claimId],
      }
    }))
  }

  detailItem(label, value) {
    return (
      <div className="claims-detail-item">
        <dt>{label}</dt>
        <dd>{value || '-'}</dd>
      </div>
    )
  }

  claimActionControl(claim) {
    const signedInEmail = getSignedInEmail()
    const { isAdmin } = this.props;
    const isClaimOwner = (claim.owner && signedInEmail && claim.owner.email === signedInEmail)

    if (isAdmin) {
      return (
        <div className="claims-action-stack">
          <Button
            onClick={ () => {
                this.openEditClaim(claim)
            }}
            variant="primary"
            size="sm"
          >
            Edit
          </Button>
          {!claim.owner &&
          <Button
            onClick={ () => {
                this.selectClaim(claim)
            }}
            variant="primary"
            size="sm"
          >
            Claim
          </Button>}
        </div>
      )
    }
    else if (!isAdmin && !claim.owner) {
      return (
        <Button
          onClick={ () => {
              this.selectClaim(claim)
          }}
          variant="primary"
          size="sm"
        >
          Claim
        </Button>
      )
    }
    else if (!isAdmin && isClaimOwner) {
      return (
        <Button
          onClick={ () => {
              this.openEditClaim(claim)
          }}
          variant="primary"
          size="sm"
        >
          Notes
        </Button>
      )
    }

    return null
  }

  claimDetails(claim, averageRating, reviewLink) {
    return (
      <dl className="claims-detail-panel">
        {this.detailItem('Claim File', this.linkToClaim(claim))}
        {this.detailItem('File Type', enumToPresentableString(claim.requestType))}
        {this.detailItem('Sender Info', claim.senderDescriptor)}
        {this.detailItem('Source', claim.howDidYouHearAboutUs)}
        {this.detailItem('Brokerage', claim.brokerage)}
        {this.detailItem('Time Received', dateToDateTimeString(claim.timeReceived))}
        {this.detailItem('Time Claimed', dateToDateTimeString(claim.timeClaimed))}
        {this.detailItem('Response Time', dateToDateTimeString(claim.timeResponded))}
        {this.detailItem('File Retained', enumToPresentableString(claim.fileRetainedStatus) || 'Pending')}
        {this.detailItem('Ownership', userToPresentableName(claim.owner))}
        {this.detailItem('Client Type', enumToPresentableString(claim.clientType))}
        {this.detailItem('Tracking Email', claim.trackingEmail)}
        {this.detailItem('Lawyer Notes', claim.lawyerNotes)}
        {this.detailItem('Admin Notes', claim.adminNotes)}
        {this.detailItem('Client Feedback', claim.hasReview ? (<span>{`(\u2605 ${averageRating.toFixed(2)}) `}<a href={reviewLink}>More Details</a></span>) : '')}
      </dl>
    )
  }

  rowsForClaim(claim) {
    const { isAdmin } = this.props;
    const signedInEmail = getSignedInEmail()
    const isClaimOwner = (claim.owner && signedInEmail && claim.owner.email === signedInEmail)

    const renderActionCell = () => {
      return (<td className="claims-col-action">{this.claimActionControl(claim)}</td>)
    }

    const reviewLink = `/claim/${claim.id}/review`
    let averageRating = 0.0
    if (claim.review) {
      const { speedOfService, qualityOfReview, friendlinessOfLawyer } = claim.review
      averageRating = (speedOfService + qualityOfReview + friendlinessOfLawyer) / 3.0
    }
    const isExpanded = !!this.state.expandedClaimIds[claim.id]
    const reviewSummary = ((isAdmin || isClaimOwner) && claim.hasReview) ? (
      <span>{`\u2605 ${averageRating.toFixed(2)}`}</span>
    ) : ''

    return (
      <React.Fragment key={claim.id}>
        <tr
          style={{ backgroundColor: claim.owner ? '#FFF2CC' : '#D9E1F2' }}
        >
          <td className="claims-col-expand">
            <Button
              aria-controls={`claim-details-${claim.id}`}
              aria-expanded={isExpanded}
              aria-label={`${isExpanded ? 'Hide' : 'Show'} details for claim ${claim.id}`}
              className="claims-expand-button"
              onClick={() => this.toggleClaimDetails(claim.id)}
              size="sm"
              variant="outline-secondary"
            >
              {isExpanded ? '\u2212' : '+'}
            </Button>
          </td>
          {renderActionCell()}
          <td className="claims-col-type claims-col-mobile" title={enumToPresentableString(claim.requestType)}>{enumToPresentableString(claim.requestType)}</td>
          <td className="claims-col-file">{this.linkToClaim(claim)}</td>
          <td className="claims-col-sender" title={claim.senderDescriptor}>{claim.senderDescriptor}</td>
          <td className="claims-col-source claims-col-wide" title={claim.howDidYouHearAboutUs}>{claim.howDidYouHearAboutUs}</td>
          <td className="claims-col-brokerage claims-col-wide" title={claim.brokerage}>{claim.brokerage}</td>
          <td className="claims-col-date" title={dateToDateTimeString(claim.timeReceived)}>{dateToDateTimeString(claim.timeReceived)}</td>
          <td className="claims-col-date claims-col-wide" title={dateToDateTimeString(claim.timeClaimed)}>{dateToDateTimeString(claim.timeClaimed)}</td>
          <td className="claims-col-date" title={dateToDateTimeString(claim.timeResponded)}>{dateToDateTimeString(claim.timeResponded)}</td>
          {isAdmin && <td className="claims-col-status claims-col-wide" title={enumToPresentableString(claim.fileRetainedStatus) || 'Pending'}>{enumToPresentableString(claim.fileRetainedStatus) || 'Pending'}</td>}
          <td className="claims-col-owner" title={userToPresentableName(claim.owner)}>{userToPresentableName(claim.owner)}</td>
          <td className="claims-col-status claims-col-wide" title={enumToPresentableString(claim.clientType)}>{enumToPresentableString(claim.clientType)}</td>
          <td className="claims-col-feedback claims-col-tablet">{reviewSummary}</td>
        </tr>
        {isExpanded &&
          <tr
            className="claims-detail-row"
            id={`claim-details-${claim.id}`}
            style={{ backgroundColor: claim.owner ? '#FFF2CC' : '#D9E1F2' }}
          >
            <td colSpan={isAdmin ? '14' : '13'}>
              {this.claimDetails(claim, averageRating, reviewLink)}
            </td>
          </tr>
        }
      </React.Fragment>
    );
  }

  cardForClaim(claim) {
    const reviewLink = `/claim/${claim.id}/review`
    let averageRating = 0.0
    if (claim.review) {
      const { speedOfService, qualityOfReview, friendlinessOfLawyer } = claim.review
      averageRating = (speedOfService + qualityOfReview + friendlinessOfLawyer) / 3.0
    }
    const isExpanded = !!this.state.expandedClaimIds[claim.id]
    const owner = userToPresentableName(claim.owner) || 'Unassigned'

    return (
      <div
        className="claims-card"
        key={claim.id}
        style={{ backgroundColor: claim.owner ? '#FFF2CC' : '#D9E1F2' }}
      >
        <div className="claims-card-main">
          <div className="claims-card-content">
            <div className="claims-card-title">{this.linkToClaim(claim)}</div>
            <div className="claims-card-subtitle" title={claim.senderDescriptor}>{claim.senderDescriptor || '-'}</div>
            <div className="claims-card-meta">
              <span>Received: {dateToDateTimeString(claim.timeReceived) || '-'}</span>
              <span>Response: {dateToDateTimeString(claim.timeResponded) || '-'}</span>
            </div>
            <div className="claims-card-owner" title={owner}>Owner: {owner}</div>
          </div>
          <div className="claims-card-actions">
            {this.claimActionControl(claim)}
            <Button
              aria-controls={`claim-card-details-${claim.id}`}
              aria-expanded={isExpanded}
              aria-label={`${isExpanded ? 'Hide' : 'Show'} details for claim ${claim.id}`}
              className="claims-expand-button"
              onClick={() => this.toggleClaimDetails(claim.id)}
              size="sm"
              variant="outline-secondary"
            >
              {isExpanded ? '\u2212' : '+'}
            </Button>
          </div>
        </div>
        {isExpanded &&
          <div className="claims-card-details" id={`claim-card-details-${claim.id}`}>
            {this.claimDetails(claim, averageRating, reviewLink)}
          </div>
        }
      </div>
    )
  }

  render() {
    const { popupClaim, editClaim } = this.state;
    const claimsByDay = this.state.claims;
    const { isAdmin } = this.props;

    if (isAdmin && editClaim) {
      return (<EditClaim isAdmin={isAdmin} claim={editClaim} didUpdateClaim={(claim) => this.editClaim(claim)} />);
    }
    if (editClaim && editClaim.owner) {
      return (<EditClaim isAdmin={isAdmin} claim={editClaim} didUpdateClaim={(claim) => this.editClaim(claim)} />);
    }

    const noClaims = claimsByDay.length === 0

    return (
      <div style={{ padding: '20px' }}>
        {noClaims && <div>No Claims</div>}
        {claimsByDay.map((claims) => (
        <React.Fragment key={claims[0].id}>
          <Table
            className="claims-table"
            style={{
              marginBottom: -1,
              width: '100%'

            }}
        >
          <thead>
            <tr style={{ width: '100%' }}>
              <th colSpan={isAdmin ? '14' : '13'}>{dateToDateString(claims[0].timeReceived)}</th>
            </tr>
            <tr>
              <th className="claims-col-expand"/>
              <th className="claims-col-action"/>
              <th className="claims-col-type claims-col-mobile">File Type</th>
              <th className="claims-col-file">Claim File</th>
              <th className="claims-col-sender">Sender Info</th>
              <th className="claims-col-source claims-col-wide">Source</th>
              <th className="claims-col-brokerage claims-col-wide">Brokerage</th>
              <th className="claims-col-date">Time Received</th>
              <th className="claims-col-date claims-col-wide">Time Claimed</th>
              <th className="claims-col-date">Response Time</th>
              {isAdmin && <th className="claims-col-status claims-col-wide">File Retained</th>}
              <th className="claims-col-owner">Ownership</th>
              <th className="claims-col-status claims-col-wide">Client Type</th>
              <th className="claims-col-feedback claims-col-tablet">Client Feedback</th>
            </tr>
          </thead>
          <tbody>
            {claims.map((claim) => ( this.rowsForClaim(claim) ))}
          </tbody>
          </Table>
          <div className="claims-card-list">
            <h3 className="claims-card-date">{dateToDateString(claims[0].timeReceived)}</h3>
            {claims.map((claim) => ( this.cardForClaim(claim) ))}
          </div>
        </React.Fragment>
        ))}
        {popupClaim &&
          <PopupAlert
            title="Claim File"
            body="Are you sure you wish to claim this file? (Once assigned to you, this file is yours and cannot be reassigned to anyone else)"
            selectedOption={(index) => {
              this.deselectClaim(index > 0 ? popupClaim : null)
            }}
          />
        }
      </div>
    );
  }
}

export default withRouter(Claims);
